// extracted by mini-css-extract-plugin
export default {"link":"M2fMh9","root":"cz5BRB","label":"G0GB9W"};